import type { ReactiveWorldsMapPackage } from "../types";

function canonical(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(canonical);
  if (!value || typeof value !== "object") return value;
  return Object.fromEntries(
    Object.entries(value as Record<string, unknown>)
      .filter(([, entry]) => entry !== undefined)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([key, entry]) => [key, canonical(entry)]),
  );
}

export function gameplayRevisionData(pkg: ReactiveWorldsMapPackage) {
  const ugc = { ...pkg.ugc };
  delete ugc.title;
  delete ugc.validation;
  delete ugc.stats;
  return canonical({
    schema: pkg.schema,
    version: pkg.version,
    schemaVersion: pkg.schemaVersion || 0,
    engineVersion: pkg.engineVersion || pkg.version,
    seed: pkg.seed || 0,
    cols: pkg.cols,
    rows: pkg.rows,
    theme: pkg.theme,
    ugc,
    cells: pkg.cells,
  });
}

export async function mapRevisionHash(pkg: ReactiveWorldsMapPackage) {
  const bytes = new TextEncoder().encode(JSON.stringify(gameplayRevisionData(pkg))),
    digest = await crypto.subtle.digest("SHA-256", bytes);
  return [...new Uint8Array(digest)].map((value) => value.toString(16).padStart(2, "0")).join("");
}
